import * as types from '../constants/actionTypes';

export function approveHoursProject(projectKey, taskKey, approvedHourKey) {
    return { type: types.APPROVE_HOURS_PROJECT, projectKey, taskKey, approvedHourKey };
}
export function archiveProject({project, status, data} = {}) {
    return { type: types.ARCHIVE_PROJECT, project, status, data };
}
export function checkProjectName({status, data} = {}) {
    return { type: types.CHECK_PROJECT_NAME, status, data };
}
export function clearError() {
    return { type: types.CLEAR_ERROR };
}
export function checkProjectNameCV({status, data} = {}) {
    return { type: types.CHECK_PROJECT_NAME_CV, status, data };
}
export function createProject({project, status, data} = {}) {
    return { type: types.CREATE_PROJECT, project, status, data };
}
export function deleteProject({projectID, status, data} = {}) {
    return { type: types.DELETE_PROJECT, projectID, status, data };
}
export function editProject({project, status, data} = {}) {
    return { type: types.EDIT_PROJECT, project, status, data };
}
export function exportProjects({dateFrom, dateTo, fileName, status, data} = {}) {
    return { type: types.EXPORT_PROJECTS, dateFrom, dateTo, fileName, status, data };
}
export function isDeletable({user, status, data} = {}) {
    return { type: types.IS_DELETABLE, user, status, data};
}
export function loadProjects({user, status, data} = {}) {
    return { type: types.LOAD_PROJECTS, user, status, data };
}
export function loadProjectsByUser({userID, status, data} = {}) {
    return { type: types.LOAD_PROJECTS_BY_USER, userID, status, data };
}
export function loadMyProjectsForWeekApproval({week, status, data} = {}) {
    return { type: types.LOAD_MY_PROJECTS_FOR_WEEK_APPROVAL, week, status, data };
}
export function loadOtherProjectsForWeekApproval({week, status, data} = {}) {
    return { type: types.LOAD_OTHER_PROJECTS_FOR_WEEK_APPROVAL, week, status, data };
}
export function pmLoadAllProjects({status, data} = {}) {
    return { type: types.PM_LOAD_ALL_PROJECTS, status, data };
}
export function pmLoadAllProjectsWithoutTasks({status, data} = {}) {
    return { type: types.PM_LOAD_ALL_PROJECTS_WITHOUT_TASKS, status, data };
}
export function pmLoadArchivedProjects({status, data} = {}) {
    return { type: types.PM_LOAD_ARCHIVED_PROJECTS, status, data };
}
export function pmLoadUnarchivedProjects({status, data} = {}) {
    return { type: types.PM_LOAD_UNARCHIVED_PROJECTS, status, data };
}
export function pmoLoadAllProjects({status, data} = {}) {
    return { type: types.PMO_LOAD_ALL_PROJECTS, status, data };
}
export function pmoLoadAllProjectsForUsersOverview({status, data} = {}) {
    return { type: types.PMO_LOAD_ALL_PROJECTS_FOR_USERS_OVERVIEW, status, data };
}
export function pmoLoadArchivedProjects({status, data} = {}) {
    return { type: types.PMO_LOAD_ARCHIVED_PROJECTS, status, data };
}
export function pmoLoadUnarchivedProjects({status, data} = {}) {
    return { type: types.PMO_LOAD_UNARCHIVED_PROJECTS, status, data };
}
export function setLoadingFlagForOtherProjectState() {
    return { type: types.SET_LOADING_FLAG_FOR_OTHER_PROJECT_STATE };
}
export function setLoadingFlagForProjectState() {
    return { type: types.SET_LOADING_FLAG_FOR_PROJECT_STATE };
}
export function setCurrentView(viewName) {
    return { type: types.SET_CURRENT_VIEW, viewName };
}
export function setSelectedProject(project) {
    return { type: types.SET_SELECTED_PROJECT, project };
}
export function unarchiveProject({project, status, data} = {}) {
    return { type: types.UNARCHIVE_PROJECT, project, status, data };
}
export function getUnbilledHoursProject({status, data} = {}) {
  return { type: types.GET_UNBILLED_TIME_ON_PROJECT, status, data}
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/projectActions.js
 **/